import imageUrlBuilder from "@sanity/image-url";
import type { SanityImageSource } from "@sanity/image-url/lib/types/types";
import { client } from "../client";

// Create an image URL builder using the client
const builder = imageUrlBuilder(client);

// Assets are already WebP. Leave off quality and auto=format so the CDN
// serves that file instead of re-encoding it or generating an AVIF variant.
const imageUrl = (source: SanityImageSource) => builder.image(source);

export default imageUrl;
